export default "__VITE_ASSET__CTVqqDjU__"